<template>
  <div
    class="flex flex-col gap-6 pa-6 w-[20vw] max-w-75 min-w-60 flex-none overflow-auto border-[1px] border-r-solid border-primary5"
    :class="{
      'bg-primary6': isFullscreen,
    }"
  >
    <div v-for="group in visibleGroups" :key="group.id" class="flex flex-col gap-2">
      <b
        v-if="hasManyGroups"
        class="color-text font-size-[15px] tracking-[0.15px] cursor-pointer self-start"
        @click="setActiveSlide(group)"
      >
        {{ group.name }} ({{ group.slides?.length }})
      </b>

      <div class="flex flex-col gap-6">
        <div
          v-for="(slide, index) in group.slides"
          :key="slide.id"
          class="flex flex-col gap-2 cursor-pointer"
          @click="setActiveSlide(group, slide)"
        >
          <div
            class="pb-[56.25%] relative collection-player__box"
            :class="{
              'collection-player__box--active': activeSlide?.id === slide.id,
            }"
          >
            <CImage
              class="rounded-1 w-full absolute top-0 left-0 right-0 bottom-0 justify-center"
              :img-props="{
                draggable: false,
                style: { borderRadius: '4px', 'max-width': '100%' },
              }"
              object-fit="contain"
              preview-disabled
              :src="slideThumbnails.get(slide.id)"
            />
          </div>

          <div
            class="self-center rounded-[2px] font-size-[14px] tracking-[0.5px] font-500 pa-[2px] min-w-12 w-12 text-center color-white"
            :class="[activeSlide?.id === slide.id ? 'bg-primary' : 'bg-primary3']"
          >
            {{ index + 1 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CImage from '@lib/components/CImage/CImage.vue'
import { useAppStore } from '@collection-player/stores/app.store'
import { computed } from 'vue'

const {
  visibleGroups,
  activeSlide,
  hasManyGroups,
  setActiveSlide,
  fullscreen: { isFullscreen },
} = useAppStore()

const slideThumbnails = computed(() => {
  const thumbnails = new Map<string, string>()

  visibleGroups.value.forEach((group) => {
    group.slides?.forEach((slide) => {
      const thumbnailUrl = slide.type === 'file' ? slide.file.thumbnail_url : slide.slide.url

      if (thumbnailUrl) {
        thumbnails.set(slide.id, thumbnailUrl)
      }
    })
  })

  return thumbnails
})
</script>
